import React, { Fragment, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import Util from "./Common/Util"

import moment from 'moment';

import "chartist/dist/scss/chartist.scss";

import { useSelector } from 'react-redux';

import { getDashBoardData, getCarState, getWasteverseBarState } from 'crud/dashboard.crud';
import { useEffect } from 'react';



const initWaverbarItem = [
  {state: 'Y'},
  {state: 'Y'},
  {state: 'N'},
  {state: 'E'},
]

 
const carBadge = {
  Y: {text: '운행중', class: 'primary-bg'},
  N: {text: '미운행', class: 'light-bg'},
  E: {text: '이상발생', class: 'error-bg'}
}
 
const waverbarBadge = {
  O: {text: '정상', class: 'primary-bg'},
  F: {text: '비활성', class: 'light-bg'},
  M: {text: '모듈오류', class: 'error-bg'},
  B: {text: '배터리오류', class: 'error-bg'},
}

const Collection = props => {
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()
  const history = useHistory()

  const [user, setUser] = useState(selector.auth?.user)
  const [myCollectSum, setMyCollectSum] = useState(0)
  const [startDate, setStartDate] = useState(moment(newDate).format('YYYY-MM-DD') + ' 00:00:00')
  const [endDate, setEndDate] = useState(moment(nextDate.setDate(nextDate.getDate() + 1)).format('YYYY-MM-DD') + ' 00:00:00')
  const [detailType, setDetailType] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]?.type || "")
  const [dashboardItem, setDashboardItem] = useState([])
  const [vehicleItem, setVehicleItem] = useState([])
  const [waverbarItem, setWaverbarItem] = useState([])


  const getTopDashBoardData = async () => {//상단 내용
    try {         
      const response = await getDashBoardData();
      if (response.data?.result === 'success') {
        const item = response.data?.data
        const summaryList = [
          { text: '전일 총 수거량', value: Util.setCommaPrice(item.yesterday_collect_qty_sum), unit: 'ℓ' },
          { text: '금월 총 수거량', value: Util.setCommaPrice(item.month_collect_qty_sum), unit: 'ℓ' },
          { text: '전일 수거 정산금액', value: Util.setCommaPrice(item.yesterday_collect_price_sum), unit: '원' },
          { text: '금월 수거 정산금액', value: Util.setCommaPrice(item.month_collect_price_sum), unit: '원' },
          { text: '전일 총 인계량', value: Util.setCommaPrice(parseInt(item.yesterday_wearing_qty_sum / 1000)), unit: 'ton' },
          { text: '금월 총 인계량', value: Util.setCommaPrice(parseInt(item.month_wearing_qty_sum)) / 1000, unit: 'ton' },
          { text: '금월 미정산 금액', value: Util.setCommaPrice(item.report_month), unit: '원', box: item.report_month_count },
          { text: '전월 미정산 금액', value: Util.setCommaPrice(item.prev_report_month), unit: '원', box: item.prev_report_month_count }
        ];
        setDashboardItem(summaryList)
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCarStateData = async () => {//차량 정보
    try {         
      const response = await getCarState();
      if (response.data?.result === 'success') {
        const item = response.data?.data
        setVehicleItem(item)
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getWasteverseBarData = async () => {//웨버바 정보
    try {         
      const response = await getWasteverseBarState();
      if (response.data?.result === 'success') {
        const item = response.data?.data
        setWaverbarItem(item)
      }
    } catch (error) {
      console.error(error);
    }
  }


  useEffect(() => {
    getTopDashBoardData()
    getCarStateData()
    getWasteverseBarData()
  }, [])

  return (
    <Fragment>
      <Row>
        {dashboardItem.length > 0 && dashboardItem.map((item, index) => (
          <Col xs={12} md={6} lg={6} xl={3} key={'dashboard_item_'+index}>
            <Card style={{ height: 150 }} className='position-relative box-border'>
              {item.box > 0 &&
                <div className='unsettled-box error-bg white-text'>{item.box}</div>
              }
              <CardBody className='d-flex flex-direction-column'>
                <Row>
                  <Col>
                    <p className='font-size-18 primary-text font-weight-bold'>{item.text}</p>
                  </Col>
                </Row>
                <Row className='justify-content-end mt-auto'>
                  <p className='fit-content mb-0 font-size-50 font-weight-800'>{Util.setCommaPrice(item.value)}<span className='font-size-18'> {item.unit}</span></p>
                </Row>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      <div className='margin-top-48'>
        <p className='font-size-16'>■ 차량별 수거 현황</p>
      </div>
      
      <Row>
        {vehicleItem.length > 0 && vehicleItem.map((item, index) => (
          <Col xs={12} md={6} lg={6} xl={3} key={'vehicle_item_'+index}>
            <Card style={{ height: 246 }} className='position-relative box-border'>
              <div className={`vehicle-box ${carBadge[item.car_state].class} white-text`}>{carBadge[item.car_state].text}</div>
              <CardBody className='d-flex flex-direction-column padding-left-21 padding-top-18'>
                <Row>
                  <Col>
                    <p className='font-size-18 primary-text font-weight-bold margin-bottom-48 line-height-1'>{item.name || ''} ({item.number})</p>
                  </Col>
                </Row>
                  <p key={'collection_item_driver'} className='fit-content mb-0 font-size-16'>- &emsp; 운반기사 : {item.driver} </p>
                  <p key={'collection_item_count'} className='fit-content mb-0 font-size-16'>- &emsp; 거래처 수 : {Util.setCommaPrice(item.collect_today.total_count || 0)} </p>
                  <p key={'collection_item_amount'} className='fit-content mb-0 font-size-16'>- &emsp; 수거 정산금액 : {Util.setCommaPrice(item.collect_today.total_amount || 0)} 원</p>
                  <p key={'collection_item_qty'} className='fit-content mb-0 font-size-16'>- &emsp; 금일 수거량 : {Util.setCommaPrice(item.collect_today.total_qty || 0)} L</p>
                  <p key={'collection_item_prev'} className='fit-content mb-0 font-size-16'>- &emsp; 전일 수거량 : {Util.setCommaPrice(item.collect_yesterday.total_qty || 0)} L</p>                  
              </CardBody>
            </Card> 
          </Col>
        ))}
      </Row>
      
      <Row>
        {waverbarItem.length > 0 && waverbarItem.map((item, index) => (
          <Col xs={12} md={6} lg={6} xl={3}>
            <Card style={{ height: 59 }} className='position-relative box-border'>
              <CardBody className='d-flex flex-direction-column padding-left-21 padding-top-20'>
                <div className='d-flex justify-content-between'>
                  <p className='mb-0 font-size-18 primary-text font-weight-bold line-height-1'>웨버바 - {item.id}</p>
                  <div className={`vehicle-box ${waverbarBadge[item.state].class} white-text`}>{waverbarBadge[item.state].text}</div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Fragment>
  )
}

export default Collection